<section>
  <div class="tool-content-container">
    <div class="tool-description">
      The table below display terms that are throughout the dashboard with
      explanations on what each term means.
    </div>

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <!-- Term Column -->
      <ng-container matColumnDef="term">
        <th mat-header-cell *matHeaderCellDef>Terms</th>
        <td
          mat-cell
          *matCellDef="let element"
          [class.highlight]="element.value === highlightedTermValue"
          [id]="element.value"
        >
          {{ element.term }}
        </td>
      </ng-container>

      <!-- Defintion Column -->
      <ng-container matColumnDef="explanation">
        <th mat-header-cell *matHeaderCellDef>Definitions</th>
        <td
          mat-cell
          *matCellDef="let element"
          [class.highlight]="element.value === highlightedTermValue"
        >
          {{ element.explanation }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</section>
